import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable } from "rxjs";
import { AddClient, AddSubClient, ClientDetail, ContactDetail, HttpResponse, SubClientDetail } from "../interfaces";
import { UserHttpService } from "./user-session.service";

@Injectable({
    providedIn: 'root'
})
export class ClientServiceHttp {
    public clientSearchCtrl: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private clientsUpdated = new BehaviorSubject<void>(undefined);
    clientsUpdated$ = this.clientsUpdated.asObservable();

    constructor(
        private http: HttpClient,
        private userService: UserHttpService
    ) { }
    /*--Function to call as and soon as a new client is added to update the list without refreshing the page--*/
    public notifyClientAdded() {
        this.clientsUpdated.next();
    }
    //Get Clients list
    public getAllClients(
        keyword_search?: string,
        cmp_name?: string,
        cmp_industry?: string,
        cmp_country?: string,
        limit?: number,
        offset?: number,
    ): Observable<HttpResponse<ClientDetail[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('cmp_name', cmp_name ? cmp_name : "");
        formData.append('cmp_industry', cmp_industry ? cmp_industry : "");
        formData.append("cmp_country", cmp_country ? cmp_country : "");
        if (keyword_search) {
            formData.append('keyword_search', keyword_search ? keyword_search : "");
        }
        if (limit !== undefined) {
            formData.append('limit', limit.toString());
        }
        if (offset !== undefined) {
            formData.append('offset', offset.toString());
        }
        return this.http.post<HttpResponse<ClientDetail[]>>("client/addClient/getCompanies", formData);
    }

    //Add Client
    public addClient(body: AddClient, isEdit: boolean = false): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('cmp_name', body.cmp_name);
        formData.append('cmp_emailid', body.cmp_emailid);
        // formData.append('cmp_emailid', body.cmp_emailid);
        formData.append('cmp_contact', body.cmp_contact);
        formData.append('cmp_industry', body.cmp_industry);
        formData.append('gstNumber', body.gstNumber);
        formData.append('cmp_address1', body.cmp_address1);
        formData.append('cmp_address2', body.cmp_address2 ? body.cmp_address2 : '');
        formData.append('cmp_country', body.cmp_country);
        formData.append('cmp_state', body.cmp_state);
        formData.append('cmp_city', body.cmp_city);
        formData.append('cmp_pincode', body.cmp_pincode);

        if (isEdit) {
            formData.append('company_id', body.company_id ? body.company_id : '');
        }

        return this.http.post<HttpResponse<any>>('client/addClient', formData);
    }

    public getClientInfo(id: string): Observable<HttpResponse<ClientDetail>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('company_id', id ? id : '');
        return this.http.post<HttpResponse<ClientDetail>>("client/editcompany", formData);
    }

    //delete client
    public deleteClient(client_id: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('client_id', client_id ? client_id : '');

        return this.http.post<HttpResponse<any>>('client/deleteClient', formData);
    }

    //All Subclient
    public getAllSubClients(
        companyId: string,
        subsidiaryName?: string,
        industry_id?: string,
        locationName?: string,
        limit?: number,
        offset?: number,
    ): Observable<HttpResponse<SubClientDetail>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('company_id', companyId);
        formData.append('subsidiaryName', subsidiaryName ? subsidiaryName : "");
        formData.append('industry_id', industry_id ? industry_id : "");
        formData.append("locationName", locationName ? locationName : "");
        if (limit !== undefined) {
            formData.append('limit', limit.toString());
        }
        if (offset !== undefined) {
            formData.append('offset', offset.toString());
        }
        return this.http.post<HttpResponse<SubClientDetail>>("client/addsubCompany/getsubCompanies", formData);
    }

    public getSubClientInfo(id: string): Observable<HttpResponse<SubClientDetail>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('subcompany_id', id ? id : '');
        return this.http.post<HttpResponse<SubClientDetail>>("client/editsubcompany", formData);
    }

    //add/update subclient
    public addSubClient(body: AddSubClient, isEdit: boolean = false): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('company_id', body.company_id);
        formData.append('subCompany_name', body.subCompany_name);
        formData.append('billing_address1', body.billing_address1);
        formData.append('billing_address2', body.billing_address2);
        formData.append('country', body.country);
        formData.append('state', body.state);
        formData.append('city', body.city);
        formData.append('postal_code', body.postal_code);
        formData.append('industry_type', body.industry_type);
        formData.append('gstNumber', body.gstNumber);
        formData.append('email', body.email);
        formData.append('contact_no', body.contact_no);

        if (isEdit) {
            formData.append('companysub_id', body.Companysub_id ? body.Companysub_id : '');
        }

        return this.http.post<HttpResponse<any>>('client/addsubCompany', formData);
    }

    //delete client
    public deleteSubClient(companysub_id: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('sub_client_id', companysub_id ? companysub_id : '');

        return this.http.post<HttpResponse<any>>('client/deleteSubClient', formData);
    }

    //All Contacts
    public getAllContacts(sub_client_id: string, limit?: number,
        offset?: number): Observable<HttpResponse<ContactDetail>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('client_id', sub_client_id);
        if (limit !== undefined) {
            formData.append('limit', limit.toString());
        }
        if (offset !== undefined) {
            formData.append('offset', offset.toString());
        }
        return this.http.post<HttpResponse<ContactDetail>>("client/contactList", formData);
    }


    public getContactInfo(id: string, contactId: string): Observable<HttpResponse<ContactDetail[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('company_id', id ? id : '');
        formData.append('contactperson_id', contactId ? contactId : '');
        return this.http.post<HttpResponse<ContactDetail[]>>("client/editClientContact", formData)
    }


    //add/update contacts
    public addContact(body: any, isEdit: boolean = false): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('company_id', body.company_id);
        formData.append('contactName', body.contactName);
        formData.append('contactEmail', body.contactEmail);
        formData.append('contactDesignation', body.contactDesignation);
        formData.append('contactMobile', body.contactMobile);
        formData.append('contactLandline', body.contactLandline);
        formData.append('contactLandlineExt', body.contactLandlineExt);
        formData.append('subsidiary_id', body.subsidiary_id);

        if (isEdit) {
            formData.append('companycontact_id', body.companycontact_id ? body.companycontact_id : '');
        }

        return this.http.post<HttpResponse<any>>('client/addCompanyContact', formData);
    }

    //delete contact
    public deleteContact(contact_id: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('contact_id', contact_id ? contact_id : '');

        return this.http.post<HttpResponse<any>>('client/deleteClientContact', formData);
    }

    //get project based activities
    public getProjectBasedActivities(project_id: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('usr_customer_track_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('project_id', project_id ? project_id : '');

        return this.http.post<HttpResponse<any>>('mytask/ActivityListForTask', formData);
    }
    //Activity wise budget
    public getActivityWiseBudget(projectId: string, activityId: string) {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('token', this.userService.userToken);
        formData.append('usr_customer_track_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('activityId', activityId ? activityId : '');
        formData.append('project_id', projectId ? projectId : '');

        return this.http.post<HttpResponse<any>>('mytask/ActivityListForTask/costDetail', formData);
    }
}